import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CusValidators } from 'wflow-cdk';
import {
  DialogComponentsModule,
  InputAutocompleteComponent,
  WuiButtonModule,
  WuiDialog,
} from 'wflow-ui';
import { DocumentTypeCore } from 'wflow-main-app/src/app/core/api';
import { usersDocumentTypeListStrategy } from 'wflow-main-app/src/app/shared/list-controllers/users-document-type-list.strategy';

@Component({
  selector: 'wf-peppol-create-document-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    TranslateModule,
    DialogComponentsModule,
    WuiButtonModule,
    InputAutocompleteComponent,
  ],
  templateUrl: './peppol-create-document-dialog.component.html',
  styleUrl: './peppol-create-document-dialog.component.scss',
  host: { class: 'wf-peppol-create-document-dialog' },
})
export class PeppolCreateDocumentDialogComponent {
  private readonly dialogRef = inject(WuiDialog);
  private readonly fb = inject(FormBuilder);

  protected readonly listStrategy = usersDocumentTypeListStrategy();

  protected readonly form = this.buildForm(this.fb);

  protected submit(): void {
    if (this.form.invalid) {
      return;
    }
    this.dialogRef.close(this.form.getRawValue().type?.id);
  }

  private buildForm(fb: FormBuilder) {
    return fb.group({
      type: [null as DocumentTypeCore | null, CusValidators.required],
    });
  }
}
